import { ComplianceResultState } from "../ComplianceResultGroups/ComplianceResultGroups.jsx";
import "./ComplianceResultItem.css";

export function ComplianceResultItem({ className = "", detail, href, status, summary }) {
  const Target = href ? "a" : "div";
  const targetProps = href ? { href } : {};
  return <Target className={`compliance-result-item${href ? " linked" : ""}${className ? ` ${className}` : ""}`} {...targetProps}>
    <ComplianceResultState status={status} />
    <div className="compliance-result-content">
      <div className="compliance-result-summary">{summary}</div>
      {detail ? <div className="compliance-result-detail">{detail}</div> : null}
    </div>
  </Target>;
}
